import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getCustomer = createAsyncThunk('customer/getCustomer', async (arg, { rejectWithValue }) => {
  try {
    const { data } = await axios.get(`${env.API_URL}/debitors/${arg}`, {
      headers: {
        jwt: localStorage.getItem('microsoftJWT'),
        Accept: 'application/json',
      },
    });
    return data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});
